import { Flag, PageSection } from '@src/components';
import { ResponsiveModal } from '@src/components/ResponsiveModal';
import { ROUTE_PACKAGE_FULL_URL } from '@src/constants/URLS.const';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CountryList } from './CountryList';
import { Region } from '@src/services/region/regionApiSliceTypes';
import { Button, Divider } from 'antd';

export function RegionCard({ region }: Readonly<{ region: Region }>) {
  const navigate = useNavigate();
  const [openCountires, setOpenCountires] = useState(false);

  const countryNames = region.countries
    ? region.countries.map((c) => c.name).join(', ')
    : [];
  const truncatedCountries =
    countryNames.length > 30 ? `${countryNames.slice(0, 30)}...` : countryNames;

  const handleSelectRegion = () => {
    navigate(`${ROUTE_PACKAGE_FULL_URL}?regionId=${region.id}`);
  };

  const flagSrc = region.imageIcon ?? region.image;

  const handleCloseCountriesList = () => {
    setTimeout(() => {
      setOpenCountires(false);
    }, 300);
  };

  return (
    <PageSection className='flex flex-col gap-4 bg-wl-background rounded-lg p-5'>
      <div className='flex items-center gap-4 min-h-16'>
        {flagSrc && <Flag flagSrc={flagSrc} />}

        <div className='flex items-start flex-col'>
          <span className='text-M-20 text-wl-on-background'>{region.name}</span>
          <span className='text-R-16 text-wl-on-background opacity-60'>
            {truncatedCountries}
          </span>
        </div>
      </div>
      <Divider className='m-0 w-full !border-wl-on-background opacity-20' />
      <div className='flex justify-between gap-4'>
        <Button
          className='btn-secondary w-1/2'
          onClick={() => {
            setOpenCountires(true);
          }}
        >
          Countries List
        </Button>
        <Button className='btn-primary  w-1/2' onClick={handleSelectRegion}>
          View Packages
        </Button>
      </div>

      <ResponsiveModal
        title={region.name}
        headerIcon={
          <img
            src={region.imageIcon}
            alt={region.name}
            className='w-8 h-8 rounded-full'
          />
        }
        isOpen={openCountires}
        onClose={handleCloseCountriesList}
        content={region.countries && <CountryList region={region} />}
      />
    </PageSection>
  );
}
